module.exports = __webpack_public_path__ + "img/icon1.72bdec11.png";